import { Box, Paper } from '@mui/material'

import TripDetails from './trip-details-old/trip-details'
import { useTripFormVariant } from './create-trip-context'

const CreateTripContent = () => {
  const variant = useTripFormVariant()

  // Carrier create/edit only mounts Load Confirmation + email dialogs.
  if (variant === 'carrier') {
    return <TripDetails />
  }

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
            overscrollBehaviorY: 'contain',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <TripDetails />
        </Box>
      </Paper>
    </Box>
  )
}

export default CreateTripContent
